import { createFileRoute } from "@tanstack/react-router";
import { DangerZonePage } from "@/features/tenant-settings/pages/danger-zone-page";

export const Route = createFileRoute("/_authed/tenants/$slug/settings/danger-zone")({
  component: DangerZonePage,
});
